<div class="footer text-center" id="footer_print">
    <hr>
    <span style="font-size:x-small">KRM INFO TECH - 5/13 Manivilan 5<sup>th</sup>Street, KK-Nagar, Aranthangi - 614616, Pudukkottai Dt.<br>
      Email: mohamedhasim.offical@gmail.com, Phone: 8524865763 || Developed by K.Mohamed Hasim, Phone No : 8524865763.</span>
</div>